import { IconHome, IconKey, IconBuildingSkyscraper, IconHeadset } from '@tabler/icons-react';
import { Card, CardBody, Nav, NavItem, NavLink } from 'reactstrap';
import { activeTab } from '../types/dashboard.types';

interface Props {
  activeTab: activeTab;
  onTabChange: (tab: activeTab) => void;
  preSaleCount: number;
  rentCount: number;
  secondaryCount: number;
  advisoryCount: number;
  visibleTabs?: activeTab[];
}

const NavigationTabDashboard = ({
  activeTab,
  onTabChange,
  preSaleCount,
  rentCount,
  secondaryCount,
  advisoryCount,
  visibleTabs = ['rent', 'secondary', 'pre-sale', 'advisory'],
}: Props) => {
  return (
    <Card className="mb-4 dv2-tabs">
      <CardBody>
        <Nav tabs>
          {visibleTabs.includes('rent') && (
            <NavItem>
              <NavLink
                className={activeTab === 'rent' ? 'active' : ''}
                onClick={() => onTabChange('rent')}
                style={{ cursor: 'pointer' }}
              >
                <IconKey size={16} className="me-2" />
                Renta ({rentCount})
              </NavLink>
            </NavItem>
          )}
          {visibleTabs.includes('secondary') && (
            <NavItem>
              <NavLink
                className={activeTab === 'secondary' ? 'active' : ''}
                onClick={() => onTabChange('secondary')}
                style={{ cursor: 'pointer' }}
              >
                <IconBuildingSkyscraper size={16} className="me-2" />
                Secondary ({secondaryCount})
              </NavLink>
            </NavItem>
          )}
          {visibleTabs.includes('pre-sale') && (
            <NavItem>
              <NavLink
                className={activeTab === 'pre-sale' ? 'active' : ''}
                onClick={() => onTabChange('pre-sale')}
                style={{ cursor: 'pointer' }}
              >
                <IconHome size={16} className="me-2" />
                PreVenta ({preSaleCount})
              </NavLink>
            </NavItem>
          )}
          {visibleTabs.includes('advisory') && (
            <NavItem>
              <NavLink
                className={activeTab === 'advisory' ? 'active' : ''}
                onClick={() => onTabChange('advisory')}
                style={{ cursor: 'pointer' }}
              >
                <IconHeadset size={16} className="me-2" />
                Agnósticas ({advisoryCount})
              </NavLink>
            </NavItem>
          )}
        </Nav>
      </CardBody>
    </Card>
  );
};

export default NavigationTabDashboard;
